import { ImSpinner } from "react-icons/im";
const Spinner = () => {
  return (
    <div className="absolute top-0 w-screen h-screen z-50 flex place-content-center">
      <ImSpinner className="animate-spin w-1/4 self-center text-yellow-300" />
    </div>
  );
};
export default Spinner;
